import React, { Component } from "react";
import "../styles/callCard.scss";
import HomeIcon from "../img/home_work.svg";
import BipononIcon from "../img/biponon.svg";
import ClipBoardIcon from "../img/pending_actions.svg";
import ClockIcon from "../img/clock-history 2.svg";
import InfoIcon from "../img/clock-history 3.svg";
import PeopleIcon from "../img/account_circle.svg";
import BkashIcon from "../img/bkash_logo.svg";
import { Tooltip } from "@material-ui/core";
import { format, formatDistanceStrict } from "date-fns";
import InfoBlock from "./infoBlock";
import InfoImage from "./infoImage";
import CallDetailsModal from "./callDetailsModal";
import isEnglishString from "../helper/isEnglishString";
import classnames from "classnames";

export default class CallCard extends Component {
  render() {
    if (!this.props.cardInfo) return null;
    const {
      outlet_image,
      qr_image_link,
      outlet__name,
      bmcc__code,
      bmcc__name,
      spot_code__code,
      spot_code__name,
      outlet_type,
      outlet__address,
      call_outcome,
      zone_aware_upload_time,
      zone_aware_start_time,

      field_force__whitelisting_number,
      field_force__name,
      field_force__reporting_manager__reporting_agency__name,
      outlet__wallet_no,
      field_force_id,
      outlet_id,
      startDate,
      endDate,
    } = this.props.cardInfo;
    return (
      <div className="new-call-card">
        <InfoBlock
          icon={BkashIcon}
          title="bKash Wallet Number"
          info={outlet__wallet_no}
          topVariant
          goToPath={`/outlets/${outlet_id}`}
          copyMsg={"Wallet number"}
          isTruncated
        />
        <InfoBlock
          icon={PeopleIcon}
          title="Field Force"
          info={field_force__whitelisting_number}
          subInfo={field_force__name}
          secondarySubInfo={
            field_force__reporting_manager__reporting_agency__name
          }
          topVariant
          goToPath={`/field-force?id=${field_force_id}&start=${format(
            new Date(startDate),
            "yyyy-MM-dd"
          )}&end=${format(new Date(endDate), "yyyy-MM-dd")}`}
          copyMsg={"Whitelisting number"}
          isSplitWords
          splitLength={20}
          isTruncated
        />
        <div className="call-images">
          <InfoImage imgSrc={outlet_image} title="Outlet" hasLargeView />
          <InfoImage imgSrc={qr_image_link} title="QR" hasLargeView />
        </div>

        <Tooltip
          title={outlet__name.length > 25 ? outlet__name : ""}
          placement="top"
        >
          <div
            className={classnames("call-outlet-name truncate", {
              "bangla-font": !isEnglishString(outlet__name),
            })}
          >
            {outlet__name}
          </div>
        </Tooltip>

        <Tooltip
          title={outlet__address.length > 35 ? outlet__address : ""}
          placement="top"
        >
          <div
            className={classnames("call-outlet-address truncate", {
              "bangla-font": !isEnglishString(outlet__address),
            })}
          >
            {outlet__address ? outlet__address : <b>No address available</b>}
          </div>
        </Tooltip>

        <div className="call-outlet-time">
          <img
            src={ClockIcon}
            className="new-call-card-info-icon"
            alt="clock-icon"
          />
          {`Uploaded
          ${formatDistanceStrict(
            new Date(zone_aware_upload_time),
            new Date()
          )} ago (${formatDistanceStrict(
            new Date(zone_aware_upload_time),
            new Date(zone_aware_start_time)
          )})`}

          <Tooltip
            placement="top"
            arrow
            title={`Uploaded at ${format(
              new Date(zone_aware_upload_time),
              "h:mm a, cccc dd MMMM, yyyy"
            )}`}
          >
            <img
              src={InfoIcon}
              className="new-call-card-info-icon"
              style={{ marginLeft: 10 }}
              alt="info-icon"
            />
          </Tooltip>
        </div>

        <div className="new-call-card-infos">
          <div className="secondary-container">
            <InfoBlock
              icon={HomeIcon}
              title="BMCC"
              info={bmcc__code}
              subInfo={bmcc__name}
              isSplitWords
              splitLength={15}
              copyMsg={"BMCC code"}
              isTruncated
            />
            <InfoBlock
              icon={HomeIcon}
              title="Spot"
              info={spot_code__code}
              subInfo={spot_code__name}
              isSplitWords
              splitLength={13}
              copyMsg={"Spot code"}
              isTruncated
            />
          </div>

          <InfoBlock
            icon={BipononIcon}
            title="Wallet type"
            info={outlet_type}
            isSplitWords
            isTruncated
          />

          <InfoBlock
            icon={ClipBoardIcon}
            title="Call outcome"
            info={call_outcome}
            isCallOutcome
            isTruncated
          />
        </div>
        <CallDetailsModal details={this.props.cardInfo} />
      </div>
    );
  }
}
